// All action types

const signup = {
  REQUEST_SIGNUP: 'REQUEST_SIGNUP',
  RECEIVE_SIGNUP_STATUS: 'RECEIVE_SIGNUP_STATUS',
  ERROR_OCURED: 'ERROR_OCURED',
  AUTH_ERRORS: 'AUTH_ERRORS'
}

export default signup



// WEBPACK FOOTER //
// ./src/routes/SignUp/actions/actionTypes.js